// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Nq1k9","story-with-ad":"_28fxN","ad-slot":"_2JpxY","items-wrapper":"_3H5Qa"};